import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class RotaFugaDBService extends DatabaseService {
    override classname: string = 'RotaFugaDBService';
    override table = 'rota_fuga';

    protected override migration: number = 1;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_edificacao", field: "edificacao_id", unique: false, multiEntry: false },
        { name: "by_andar", field: "andar_id", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false }
    ];
}
